import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, LoginData } from '../../services/auth';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login.html',
  styleUrl: './login.css'
})
export class LoginComponent {
  loginData: LoginData = {
    email: '',
    password: ''
  };
  
  isLoading = false;
  errorMessage = '';
  /** Set when the auth interceptor sent the user here after a 401 (§0cr). */
  sessionExpired = false;
  private returnUrl = '/dashboard';

  constructor(
    private authService: AuthService,
    private router: Router,
    route: ActivatedRoute
  ) {
    const params = route.snapshot.queryParamMap;
    this.sessionExpired = params.get('reason') === 'expired';
    const returnUrl = params.get('returnUrl');
    // Only an in-app path: a full URL here would make login an open redirect.
    if (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//') && !returnUrl.startsWith('/login')) {
      this.returnUrl = returnUrl;
    }
  }

  onSubmit(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.authService.login(this.loginData).subscribe({
      next: (response) => {
        if (response.success) {
          this.router.navigateByUrl(this.returnUrl);
        } else {
          this.errorMessage = 'Login failed';
        }
      },
      error: (error) => {
        this.errorMessage = error.error?.error || 'Login failed';
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  goToRegister(event: Event) {
    event.preventDefault();
    this.router.navigate(['/register']);
  }
} 